import { usePopper } from 'react-popper';
import React, { useLayoutEffect, useState } from 'react';

export type PopperOptions = Parameters<typeof usePopper>[2];

interface PopperComponentProps {
  reference: JSX.Element;
  visible: boolean;
  options?: PopperOptions;
  sameWidth?: boolean;
  referenceClassName?: string;
  contentClassName?: string;
}

const popperDefaultOptions: PopperOptions = {
  placement: 'bottom-start',
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [10, -10],
      },
    },
  ],
};

export const PopperComponent: React.FC<PopperComponentProps> = ({
  children,
  reference,
  visible,
  options = popperDefaultOptions,
  sameWidth,
  referenceClassName = '',
  contentClassName = '',
}) => {
  const [referenceEl, setReferenceEl] = useState<HTMLDivElement | null>(null);
  const [popperEl, setPopperEl] = useState<HTMLDivElement | null>(null);

  const { styles, attributes, update } = usePopper(
    referenceEl,
    popperEl,
    options
  );

  useLayoutEffect(() => {
    let isMounted = true;
    isMounted && update?.();
    return () => {
      isMounted = false;
    };
  }, [visible]);

  return (
    <>
      <div ref={setReferenceEl} className={referenceClassName}>
        {reference}
      </div>
      <div
        ref={setPopperEl}
        {...attributes.popper}
        style={{
          ...styles.popper,
          ...(sameWidth ? { minWidth: referenceEl?.scrollWidth } : {}),
        }}
        className={`${visible ? 'block z-5' : 'hidden'} ${contentClassName}`}
      >
        {children}
      </div>
    </>
  );
};
